<template>
    <section class="recently-viewed remove-visual" :class="{ visible: hasItems }">
        <div class="recently-viewed-content" v-if="hasItems">
            <div class="recently-viewed-header" v-if="!viewAll">
                <span class="recently-viewed-header__headline" style="margin:0 15px 0 0;">Your recently viewed items</span>
                <a href="#" class="recently-viewed-clear" @click.prevent="clearRecentlyViewedItems">Clear history</a>
            </div>
            <div class="recently-viewed-items">
                <a
                    v-for="(item, index) in items.slice(0, limit)"
                    :href="item.url"
                    :title="getItemFullname(item)"
                    @click="trackClick(item, index)"
                    :key="item.id"
                    class="recently-viewed-item"
                >
                    <img
                        :src="item.image120"
                        :alt="getItemFullname(item)"
                        width="80"
                        height="80"
                        loading="lazy"
                        decoding="async"
                    >
                </a>
            </div>
            <div class="recently-viewed-actions" v-if="viewAll">
                <a href="/store/recently-viewed-items">
                    See all your recently viewed items
                    <svg-icon name="arrow-chevron-right"></svg-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        props: {
            limit: {
                type: Number,
                required: false,
                default: 15,
            },
            viewAll: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        data() {
            return {
                observer: false,
            };
        },
        computed: {
            hasItems() {
                return this.items.length > 0
            },
            ...mapGetters({
                items: 'user/recentlyViewedItems',
            }),
        },
        methods: {
            ...mapActions({
                clearRecentlyViewedItems: 'user/clearRecentlyViewedItems'
            }),
            getItemFullname(item) {
                var fullname = `${item.manufacturer.name} ${item.productName}`;
                return (fullname).replace('"','quote');
            },
            isVisible(index) {
                return this.visible.indexOf(`${index}`) !== -1;
            },
            observe(entries) {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio === 1) {
                        entry.target.classList.add('visible');
                    } else {
                        entry.target.classList.remove('visible');
                    }
                });
            },
            trackClick(item, index) {
                axios.post('/mrt.php', {
                    RPC: '1',
                    type: 'viewhistory',
                    itemid: item.itemid,
                    position: index + 1,
                    ref: item.ref,
                    view: item.view,
                });
            },
        },
        updated() {
            if (this.items.length) {
                if (this.observer === false) {
                    this.observer = new IntersectionObserver(this.observe, {
                        root: this.$el.getElementsByClassName('recently-viewed-content')[0],
                        threshold: 1,
                    });
                }
                [...this.$el.getElementsByTagName('img')].forEach((el) => {
                    this.observer.observe(el);
                });
            }
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/scss">
    @import '~@sweetwater/sass-resources/sass';

    $img-size-small: 55;
    $img-size-medium: 65;
    $img-size-large: 80;
    $img-padding: 2;

    .recently-viewed {
        visibility: hidden;

        &.visible {
            visibility: visible;
        }
    }

    @media only percy {
	    .hide-visual {
	        visibility: hidden;
	    }

        .remove-visual {
            display: none;
        }
    }

    .recently-viewed-header {
        margin-bottom: 10px;
        font-size: 1rem;
    }

    .recently-viewed-header__headline {
        display: inline;
        font-size: 1rem;
        font-weight: 600;
        margin: 0 15px 0 0;
    }

    a.recently-viewed-clear {
        color: tint($dark-grey, 30%);
        font-size: 0.8rem;
        text-decoration: underline;
    }

    .recently-viewed-content {
        background: #fff;
        border-top: 1px solid $border-grey;
        overflow: hidden;
        padding: 16px;
        text-align: center;
        white-space: nowrap;
    }

    .recently-viewed-items {
        text-align: center;
    }

    .recently-viewed-item {
        position: relative;
        display: inline-block;
        height: ($img-size-small + ($img-padding * 2)) * 1px;
        margin: 0 ($img-padding * 1px);
        padding: ($img-padding * 1px);
        width: ($img-size-small + ($img-padding * 2)) * 1px;

        @include media('>=xsmall') {
            height: ($img-size-medium + ($img-padding * 2)) * 1px;
            width: ($img-size-medium + ($img-padding * 2)) * 1px;
        }

        @include media('>=small') {
            height: ($img-size-large + ($img-padding * 2)) * 1px;
            width: ($img-size-large + ($img-padding * 2)) * 1px;
        }

        &::after {
            bottom: 0;
            content: '';
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
        }

        .not-touch-device &:hover::after {
            background: rgba($dark-grey, 0.08);
        }
    }

    .recently-viewed-item img {
        display: block;
        height: $img-size-small * 1px;
        opacity: 0;
        width: $img-size-small * 1px;

        @include media('>=xsmall') {
            height: $img-size-medium * 1px;
            width: $img-size-medium * 1px;
        }

        @include media('>=small') {
            height: $img-size-large * 1px;
            width: $img-size-large * 1px;
        }
    }

    .recently-viewed-item img.visible {
        opacity: 1;
    }

    .recently-viewed-actions {
        font-size: getrem(14px);
        margin-top: 16px;
    }

    .recently-viewed-actions .icon--svg {
        display: inline-block;
        fill: currentColor;
        height: 10px;
        width: 10px;
    }
</style>
